module.exports = __webpack_public_path__ + "a18f0b974cb4b85cf1478bc762462c6c.png";